import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatBottomSheet } from "@angular/material";
import {
  CpsFilterPayload,
  CpsMultipleSelectorComponent,
} from "./cps-multiple-selector/cps-multiple-selector.component";


@Component({
  selector: "app-cps-autocomplete",
  templateUrl: "./cps-autocomplete.component.html",
  styleUrls: ["./cps-autocomplete.component.scss"],
})
export class CpsAutocompleteComponent implements OnInit, OnChanges {
  @Input() public fieldName: string;
  @Input() public model: string;
  @Input() public label: string;

  @Output() public change = new EventEmitter<{
    name: string;
    value: CpsFilterPayload;
  }>();

  public filterPayload: CpsFilterPayload = { defined: [], values: "" };

  constructor(private bottomSheet: MatBottomSheet) {}

  ngOnInit() {
    if (this.model) {
      this.parseModel();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.model) {
      return;
    }
    if (changes.model.firstChange) {
      return;
    }
    if (changes.model.currentValue) {
      this.parseModel();
    } else {
      this.filterPayload = { defined: [], values: "" };
    }
  }

  public open() {
    this.bottomSheet
      .open(CpsMultipleSelectorComponent, {
        data: {
          selected: {
            defined: this.filterPayload.defined.slice(),
            values: this.filterPayload.values,
          },
          selection: [],
        },
      })
      .afterDismissed()
      .subscribe((result: CpsFilterPayload | undefined) => {
        if (result == null) {
          return;
        }
        const prev = JSON.stringify(this.filterPayload);
        const next = JSON.stringify(result);
        if (prev !== next) {
          this.change.emit({
            name: this.fieldName,
            value: result,
          });
        }
        this.filterPayload = {
          defined: result.defined.slice(),
          values: result.values,
        };
      });
  }

  public hasFilterValue(): boolean {
    return (
      this.filterPayload.defined.length > 0 ||
      !!String(this.filterPayload.values || "").trim()
    );
  }

  private parseModel() {
    if (!this.model) {
      this.filterPayload = { defined: [], values: "" };
      return;
    }

    let parsed: any;
    try {
      parsed = JSON.parse(this.model);
    } catch {
      this.filterPayload = { defined: [], values: "" };
      return;
    }

    if (
      parsed &&
      typeof parsed === "object" &&
      !Array.isArray(parsed) &&
      Array.isArray(parsed.defined)
    ) {
      this.filterPayload = {
        defined: parsed.defined.map(String),
        values: typeof parsed.values === "string" ? parsed.values : "",
      };
      return;
    }

    if (Array.isArray(parsed)) {
      this.filterPayload = {
        defined: parsed.map(String),
        values: "",
      };
      return;
    }

    this.filterPayload = { defined: [], values: "" };
  }
}
